/**
* Interactive Map JS
* -----------------------------------------------------------------------------
*
* All the JS for the Interactive Map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'interactive-map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.interactive-map .point-title' ).on( 'click', function() {
        $( $( this ).attr( 'data-target' ) ).trigger( 'click' );
      } );

      $( '.interactive-map .point' ).on( 'toggleAfter', function() {
        if ( window.innerWidth > 1024 ) {
          if ( $( this ).position().left > $( this ).closest( '.image-wrapper' ).width() * 0.5 ) {
            $( '#' + $( this ).attr( 'aria-controls' ) ).addClass( 'is-pushed-left' );
          }
        } else {
          if ( $( this ).position().left > $( this ).closest( '.image-wrapper' ).width() * 0.60 ) {
            $( '#' + $( this ).attr( 'aria-controls' ) ).addClass( 'is-pushed-left' );
          } else if ( $( this ).position().left < $( this ).closest( '.image-wrapper' ).width() * 0.25 ) {
            $( '#' + $( this ).attr( 'aria-controls' ) ).addClass( 'is-pushed-right' );
          }
        }

        $( this ).trigger( 'focus' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'interactive-map', COMPONENT );
} )( app );
